"use client";

import { useEffect } from "react";

// The marketing chrome (Nav/Footer) is the cream, LIGHT-ONLY lp design
// system — landing.css hardcodes its colors and "data-theme is ignored on
// purpose". The not-yet-restyled marketing pages (/docs, /pricing, /contact)
// still use the panel's theme-aware glass styling, so with the panel default
// (dark) they rendered a dark body between a white-island Nav and a cream
// Footer. Pinning <html data-theme="light"> while a marketing route is
// mounted keeps that content on its light palette so the whole page reads
// as one light design.
const PIN_SCRIPT = `document.documentElement.dataset.theme = "light";`;

export function LightThemePin() {
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = "light";

    // Providers re-applies the stored theme from localStorage in its own
    // effect, which fires AFTER this one (parent effects run after their
    // children's) and would undo the pin — so guard the attribute for as
    // long as a marketing route is mounted.
    const observer = new MutationObserver(() => {
      if (root.dataset.theme !== "light") root.dataset.theme = "light";
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => {
      observer.disconnect();
      // Mirror the root layout boot script: dark unless the user explicitly
      // chose light — so leaving marketing restores the panel's real theme.
      let stored: string | null = null;
      try {
        stored = window.localStorage.getItem("theme");
      } catch {
        // private mode / storage blocked — fall through to dark
      }
      root.dataset.theme = stored === "light" ? "light" : "dark";
    };
  }, []);

  // Inline script so direct server-rendered loads paint light before React
  // hydrates (the <head> boot script has already run and picked dark).
  return <script dangerouslySetInnerHTML={{ __html: PIN_SCRIPT }} />;
}
